import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * A page that moved keeps its old address working: redirects to `to`, carrying the query string, so a
 * bookmark or a deep link such as `?tab=backfill` still lands where it meant to.
 */
const MovedTo: React.FC<{ to: string }> = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};

export default MovedTo;
